const MEDIA_ITEMS = [
  {
    title: '流浪地球3 预告解析',
    desc: '深度解析流浪地球3最新预告片中的隐藏细节与彩蛋，科幻迷不可错过的前瞻分析。',
    duration: '15:32',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20scene%20with%20massive%20spaceship%20near%20a%20dying%20sun%2C%20warm%20orange%20and%20deep%20blue%20cosmic%20background%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20film%20poster%20style%20composition%2C%20atmospheric%20and%20immersive%2C%20no%20text%20no%20logos%20clean%20cinematic%20look&width=800&height=560&seq=media-poster-01-v1&orientation=landscape',
  },
  {
    title: '封神第二部 幕后特辑',
    desc: '走进封神第二部拍摄现场，揭秘国产奇幻史诗大片的制作过程与特效幕后故事。',
    duration: '22:08',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20palace%20interior%20with%20golden%20dragon%20carvings%20and%20flowing%20silk%20banners%2C%20warm%20amber%20torch%20light%2C%20mystical%20atmosphere%2C%20epic%20fantasy%20film%20production%20style%2C%20rich%20textures%2C%20ornate%20details%2C%20no%20text%20no%20logos&width=800&height=560&seq=media-poster-02-v1&orientation=landscape',
  },
  {
    title: '动作电影经典场面盘点',
    desc: '回顾速度与激情、碟中谍等系列最令人热血沸腾的经典动作场面，燃爆肾上腺素。',
    duration: '18:45',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=High-speed%20car%20chase%20scene%20in%20golden%20hour%20desert%20highway%2C%20dust%20and%20motion%20blur%2C%20dramatic%20warm%20sunset%20lighting%2C%20action%20film%20aesthetic%2C%20cinematic%20wide%20shot%2C%20intense%20atmosphere%2C%20no%20text%20no%20logos%20professional%20film%20look&width=800&height=560&seq=media-poster-03-v1&orientation=landscape',
  },
  {
    title: '2026年最值得期待电影',
    desc: '盘点2026年度即将上映的超级大片，从科幻到动画，提前锁定你的年度观影清单。',
    duration: '12:56',
    views: '112万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinema%20auditorium%20with%20glowing%20movie%20screen%20displaying%20vibrant%20colorful%20abstract%20light%20patterns%2C%20red%20velvet%20seats%2C%20warm%20ambient%20theater%20lighting%2C%20anticipation%20mood%2C%20elegant%20composition%2C%20no%20text%20no%20logos%20cinematic%20atmosphere&width=800&height=560&seq=media-poster-04-v1&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选影评与解析
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            深度解读热门电影，全方位了解影片幕后故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    target.parentElement!.classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2 flex items-center gap-2">
                  <span className="flex items-center gap-1 px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs">
                    <i className="ri-play-circle-line text-sm"></i> {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-1 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i> {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}